import { Redirect } from "react-router-dom";
import Routes from "../../utils/routes";

const Home = () => {
  return <Redirect to={Routes.EVENT} />;
};

export default Home;
